import { PowerTransformerTypeState } from './types';

const state = (): PowerTransformerTypeState => {
  return {
    powerTransformerTypes: [],
  };
};

export default state;
